<p-autoComplete
  dataKey="id"
  field="firstName"
  [(ngModel)]="value"
  [placeholder]="'Admins'"
  [suggestions]="filteredAdmins"
  [dropdown]="true"
  [forceSelection]="true"
  (completeMethod)="onFilterSuggestions($event)"
  [disabled]="disabled"
  appendTo="body"
>
  <ng-template pTemplate="selectedItem" let-value>
    <div *ngIf="value" class="flex align-items-center gap-2">
      <div class="flex flex-column">
        <span class="font-medium">{{ (((value.firstName || '') + ' ' + (value.lastName || '')).trim()) }}</span>
        <small class="text-color-secondary">{{ value.email }}</small>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="item" let-value>
    <div class="flex align-items-center gap-2">
      <div class="flex flex-column">
        <span class="font-medium">{{ (((value.firstName || '') + ' ' + (value.lastName || '')).trim()) }}</span>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="empty" let-option>
    <div class="text-center p-3">
      <i class="pi pi-users text-color-secondary"></i>
      <p class="text-color-secondary">No admins available</p>
    </div>
  </ng-template>
</p-autoComplete>
